<div class="card text-left h-100">
  <div class="card-header bg-light">
    <h4 class="card-title mb-0">{{ titulo }} Programa de Trabalho</h4>
  </div>

  <div class="card-body wrapper m-0">
    <form class="needs-validation" novalidate id="myForm" #f="ngForm">
      <div class="row mt-2">

        <div class="col-sm-4">
          <label for="numeroOsa" class="form-label">Nº Osa</label>
          <input type="text" name="numeroOsa" class="form-control form-control-sm" id="numeroOsa" disabled
            placeholder="-" [(ngModel)]="numeroOsa" [ngModelOptions]="{standalone: true}" />
        </div>

        <div class="col-sm-4">
          <label for="nomeUG" class="form-label">UG. Auditada</label>
          <input type="text" name="nomeUG" class="form-control form-control-sm" id="nomeUG" disabled placeholder="-"
            [(ngModel)]="unidadeGestoraNome" [ngModelOptions]="{standalone: true}" />
        </div>

      </div>

      <div class="row mt-2">
        <div class="col-sm-12">
          <div class="d-flex align-items-center w-100 mb-2">
            <label class="form-label mb-0">Questões de Auditoria</label>

            <button type="button" class="btn btn-primary btn-sm ml-auto" *ngIf="!visualizar"
              (click)="addQuestaoIncidental(model)">
              <i class="fas fa-plus"></i> Adicionar Questão Incidental
            </button>
          </div>
          <div class="mat-elevation-z1">

            <table mat-table [dataSource]="dataSource" class="w-100" matSort matSortActive="ordem"
              matSortDirection="asc">

              <!-- Identificador -->
              <ng-container matColumnDef="identificador">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Identif.</th>
                <td mat-cell *matCellDef="let element">{{ element.identificador || '' }}</td>
              </ng-container>

              <!-- Descrição -->
              <ng-container matColumnDef="descricao">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Questão</th>
                <td mat-cell *matCellDef="let element">
                  {{ element.questaoId ? element.questao.nome : element.descricao }}
                </td>
              </ng-container>

              <!-- Tipo -->
              <ng-container matColumnDef="tipo">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Tipo da Questão</th>
                <td mat-cell *matCellDef="let element">{{ element.tipoDesc }}</td>
              </ng-container>

              <!-- Avaliação -->
              <ng-container matColumnDef="avaliacao">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Avaliação</th>
                <td mat-cell *matCellDef="let element">{{ element.avaliacaoDesc || '' }}</td>
              </ng-container>

              <!-- Responsável -->
              <ng-container matColumnDef="responsavel">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Responsável pela Última Alteração</th>
                <td mat-cell *matCellDef="let element">{{ element.responsavelNome || '' }}</td>
              </ng-container>

              <!-- Status -->
              <ng-container matColumnDef="status">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Status</th>
                <td mat-cell *matCellDef="let element">
                  <span *ngIf="element.status === 0" class="badge bg-gray-dark text-xs">{{ element?.statusDesc }}</span>
                  <span *ngIf="element.status === 1" class="badge bg-success text-xs">{{ element?.statusDesc }}</span>
                  <span *ngIf="element.status === 2" class="badge bg-warning text-xs">{{ element?.statusDesc }}</span>
                </td>
              </ng-container>

              <!-- Actions -->
              <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef>Ações</th>
                <td mat-cell *matCellDef="let element">
                  <div class="d-flex justify-content-center align-items-center">
                    <button type="button" class="btn btn-primary btn-xs ml-1" title="Responder" *ngIf="!visualizar"
                      (click)="modalResponder('Responder', false, element)">
                      <i class="fas fa-pen"></i>
                    </button>
                    <button type="button" class="btn btn-info btn-xs ml-1" title="Visualizar"
                      (click)="modalResponder('Visualizar', true, element)">
                      <i class="far fas fa-eye"></i>
                    </button>
                    <button type="button" class="btn btn-warning btn-xs ml-1" title="Histórico"
                      (click)="modalHistorico(element)">
                      <i class="fas fa-history"></i>
                    </button>

                    <button type="button" class="btn btn-primary btn-xs ml-1" title="Alterar Questão Incidental"
                      *ngIf="!visualizar && element.tipo === 2" (click)="alterarQuestaoIncidental(element)">
                      <i class="fas fa-pen"></i>
                    </button>

                    <button type="button" class="btn btn-info btn-xs ml-1" title="Visualizar Questão Incidental"
                      *ngIf="element.tipo === 2" (click)="visualizarQuestaoIncidental(element)">
                      <i class="far fas fa-eye"></i>
                    </button>

                    <button type="button" *ngIf="!visualizar && element.tipo === 2" class="btn btn-danger btn-xs ml-1"
                      (click)="excluirQuestaoIncidental(element)" title="Excluir Questão Incidental">
                      <i class="fa fa-trash"></i>
                    </button>
                  </div>
                </td>
              </ng-container>

              <!-- Header and Row -->
              <tr mat-header-row
                *matHeaderRowDef="['identificador', 'descricao', 'tipo', 'avaliacao', 'responsavel', 'status', 'actions']">
              </tr>
              <tr mat-row
                *matRowDef="let row; columns: ['identificador', 'descricao', 'tipo', 'avaliacao', 'responsavel', 'status', 'actions']">
              </tr>

            </table>

            <h5 class="table-no-data" [hidden]="dataSource?.data?.length > 0">
              Nenhum registro encontrado
            </h5>

            <!-- Paginador -->
            <mat-paginator [pageSizeOptions]="[15, 30, 50]" showFirstLastButtons></mat-paginator>

          </div>
        </div>
      </div>
    </form>
  </div>

  <div class="card-footer">
    <div class="d-flex justify-content-between align-items-center">
      <div class="list2">
        <button type="button" class="btn btn-default btn-sm" (click)="fechar()">
          <i class="fas fa-times"></i> Fechar
        </button>
      </div>
    </div>
  </div>
</div>